import { Box, SectionHeading } from '../common/ui';
export default function SectionHeadingContainer({
  title,
  index,
}: {
  title: string;
  index: number;
}) {
  return (
    <Box
      sx={{
        width: ['100%', 214],
        flexShrink: 0,
        flexGrow: 0,
        pr: [0, 16],
      }}
    >
      {index === 0 && <SectionHeading>{title}</SectionHeading>}
    </Box>
  );
}
